import React, { Component } from "react";
import {Link} from 'react-router-dom'
import DataTable from "react-data-table-component";

const data = [
  {
    id: 1,
    user: "Test One",
    email: "react1infoware@gmail.com",
    type: "SuperAdmin",
    subscription_date: "21/03/2020",
    validity:"24/06/2020",
    courses: "3"
  },
  {
    id: 2,
    user: "Test Two",
    email: "react@gmail.com",
    type: "Trainer",
    subscription_date: "04/03/2020",
    validity:"23/09/2020",
    courses: "5"
  },
  {
    id: 3,
    user: "Test Three",
    email: "infoware@gmail.com",
    type: "Learner",
    subscription_date: "20/03/2020",
    validity:"28/10/2020",
    courses: "8"
  }
];
const columns = [
  {
    name: "User",
    selector: "user",
    sortable: true
  },
  {
    name: "Email",
    selector: "email",
    sortable: true,
    right: true
  },
  {
    name: "Subcription Date",
    selector: "subscription_date",
    sortable: true,
    right: true
  },
  {
    name: "Validity",
    selector: "validity",
    sortable: true,
    right: true
  },
  {
    name: "Courses",
    selector: "courses",
    sortable: true,
    right: true
  },
  {
    name: "Options",
    selector: "year",
    sortable: true,
    right: true,
    cell: row => (
      <div className="d-flex">
        <div className="btn btn-light shadow-sm mx-1">
          <i class="fas fa-pencil-alt text-primary"></i>
        </div>
        <div className="btn btn-light shadow-sm mx-1">
          <i class="fas fa-times text-danger"></i>
        </div>
      </div>
    )
  }
];
export default class Subscriptions extends Component {
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                <Link to="/admin/dashboard">Home</Link> /<b> Subscriptions</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
               
              </div>
            </div>
          </div>

          <div className="users-container p-2">
            <DataTable
              noHeader={true}
              columns={columns}
              data={data}
              theme="solarized"
            />
          </div>
        </div>
      </div>
    );
  }
}
